import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Aviso benigno do navegador — não deve derrubar o overlay de erros do dev server
const RO_MSG = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (RO_MSG.test(e.message || "")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// FASE 14 — PWA service worker (offline app shell + API cache)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((err) => {
      console.warn("SW registration failed", err);
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
